import React from 'react'
import { Box, SxProps, Typography } from '@mui/material'

import Image from '@components/Image'

export type ClientProps = {
  clientname: string
  clientdesignation: string
  clientcontent: string
  clientimage: { asset: { _ref: string } }
}

type TestimonialProps = {
  isContactTestimonial: boolean
  data?: {
    node: ClientProps
  }
  sx?: SxProps
  sxContainer?: SxProps
} & ClientProps

export const ContentTestimonial = ({
  isContactTestimonial,
  clientname,
  clientdesignation,
  clientimage,
  clientcontent,
  data,
  sx,
  sxContainer,
}: TestimonialProps) => (
  <Box
    sx={{
      maxWidth: 1152,
      mx: 'auto',
      position: 'relative',
      pb: { xs: 5, tablet: 7 },
      pt: { xs: 7, tablet: 5, laptop: 8 },
      ...sxContainer,
    }}>
    <Box
      sx={{
        bgcolor: 'background.default',
        border: 1,
        borderColor: 'border.main',
        borderRadius: 4,
        position: 'relative',
        pb: 4,
        pt: 8,
        px: { xs: 4, mobile: 3, laptop: 6 },
        ...sx,
      }}>
      <Box
        component='img'
        src='/images/quote-blue-icon.png'
        alt='quotes'
        sx={{
          width: 80,
          top: -32,
          position: 'absolute',
        }}
      />

      <Typography
        sx={{ color: 'text.secondary', fontSize: { xs: 18, laptop: 20 } }}>
        {isContactTestimonial ? clientcontent : data?.node.clientcontent}
      </Typography>

      <Box sx={{ alignItems: 'center', display: 'flex', mt: 3 }}>
        <Box sx={{ img: { maxWidth: 64, minWidth: 64, height: 64 } }}>
          <Image
            props={
              isContactTestimonial
                ? clientimage?.asset?._ref
                : data?.node.clientimage.asset?._ref
            }
          />
        </Box>
        <Box sx={{ ml: 5 }}>
          <Typography variant='body2' sx={{ color: 'text.secondary' }}>
            -{isContactTestimonial ? clientname : data?.node.clientname}
          </Typography>
          <Typography variant='body2' sx={{ color: 'text.secondary' }}>
            {isContactTestimonial
              ? clientdesignation
              : data?.node.clientdesignation}
          </Typography>
        </Box>
      </Box>
    </Box>
  </Box>
)
